
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { createToolbarEvent, sendAnalytics } from '../../analytics';
import { INVITE_ENABLED, getFeatureFlag } from '../../base/flags';
import { Icon, IconInviteMore } from '../../base/icons';
import { getBrandingColorPalette } from '../../base/styles';
import Tooltip from '../../base/tooltip/components/Tooltip';
import { beginAddPeople } from '../../invite';


export const InviteButton = ({ textToDisplay, tooltip = true, totalPages }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    // const state = useSelector();
    const flag = useSelector(state => getFeatureFlag(state, INVITE_ENABLED, true));

    const { disableInviteFunctions, interfaceConfig } = useSelector(state => state['features/base/config']);
    const visible = flag && !disableInviteFunctions;

    const onInvite = useCallback(() => {
        sendAnalytics(createToolbarEvent('invite'));
        dispatch(beginAddPeople());
    }, [ dispatch ]);

    const participantsInviteStyle = {
        background: getBrandingColorPalette(interfaceConfig)?.secondary
    };

    return visible && (tooltip ? (
        <div>
            <Tooltip
                content = { t('participantsPane.actions.invite') }
                position = { 'top' }>
                <div
                    className = { `toolbox-icon invite-button participants_invite ${totalPages > 1 ? '' : 'has-pages'}` }
                    onClick = { () => onInvite() }
                    style = { participantsInviteStyle }>
                    <Icon src = { IconInviteMore } />
                    <p className = 'invite-button-text'>
                        {textToDisplay === undefined
                            ? t('participantsPane.actions.invite')
                            : textToDisplay}
                    </p>
                </div>
            </Tooltip>
        </div>
    ) : (
        <div
            className = { totalPages > 1 ? 'participants_invite' : 'participants_invite has-pages' }
            onClick = { () => onInvite() }
            style = { participantsInviteStyle }>
            <Icon
                size = { 20 }
                src = { IconInviteMore } />
            <p>
                {textToDisplay === undefined
                    ? t('participantsPane.actions.invite')
                    : textToDisplay}
            </p>
        </div>
    ));
};
